interface ISearchIcon {
  className?: string;
  color?: string;
}

const SearchIcon: React.FC<ISearchIcon> = ({
  className,
  color = 'currentColor',
}): JSX.Element => {
  return (
    <svg
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
      className={`w-6 h-6 ${className}`}
    >
      <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
    </svg>
  );
};

export { SearchIcon };
